import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import BaseStepper from "../../components/modules/BaseStepper";
import PageLayout from "../../layouts/PageLayout";
import { resetCampaignToCreateState } from "../../redux/reducers/campaignToCreate";
import { steps } from "./steps";

const ManagedCampaignCreatePage = () => {
  const history = useHistory();

  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(resetCampaignToCreateState());
    history.push("/dashboard");
  };

  return (
    <PageLayout heading="Ad Campaign Creation">
      <BaseStepper steps={steps} handleBack={handleBack} lastStepNextLabel="Create" nonLinear />
    </PageLayout>
  );
};

export default ManagedCampaignCreatePage;
